module.exports = __webpack_public_path__ + "static/media/trasparent.cc26a525.png";